<h2>{{searchName}} Search</h2>
<form [formGroup]="form" (ngSubmit)="submit()" autocomplete="off">
	<fieldset>
		<div class="row">
			<div class="col-sm-4 mvd_form-group">
				<label>{{searchName}}</label>
				<div class="search--input">
					<input class="mvd_form-control" id="search" type="text" placeholder="Search by: {{searchName}}" formControlName="searchString" />
				</div>
			</div>
			<div class="col-sm-4 mvd_form-group">
				<label>Exact Match</label>
				<input  name="isExact" type="checkbox" formControlName="isExact" />
			</div>
		</div>
	</fieldset>

	<div class="well__footer">
		<div class="btn--group">
			<button class="btn--default" type="button" (click)="reset();">Reset</button>
			<button class="btn--primary" title="Search" type="submit">Find</button>
		</div>
	</div>
</form>